import React from "react";
import image from "../images";
import "../css/pet.css"

function Pet({pets}) {
   
    return (


        <div className="pic-box">
            <div className="info-img">
                {pets&&<img className="info-pet-pic" src={pets.petImageUrl} alt="pets-pic" />}
                <img className="info-vector-pic" src={image.vectorBlue} alt="vector" />
            </div>
        </div>

    );
}


export default Pet;